<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <b-avatar text="JH" class="text-center pt-2 pr-1"></b-avatar>
          <base-dropdown :title="myTitle">
            <router-link class="dropdown-item" to="/changepassword">Změna hesla</router-link>
            <div class="divider"></div>
            <a class="dropdown-item" href="#" @click="logout">Odhlásit se</a>
          </base-dropdown>
        </ul>
      </div>
    </div>
</nav>
</template>

<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        myTitle: this.$store.getters.getUser.Name + ' ' + this.$store.getters.getUser.Surname
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      logout() {
        this.$store.dispatch('logout');
        this.$router.push('/login');
      }
    }
  }

</script>